// extracted by mini-css-extract-plugin
export default {"button":"LangMenu_button__VUYZ4","flag":"LangMenu_flag__agXk+","langButtonContainer":"LangMenu_langButtonContainer__PiOuD","blue":"LangMenu_blue__bAlpo"};